<template>
  <div class="paddbox autobox">
    <div>
      <el-card>
        <div class="selected-bar">
          <div class="selected-bar-left">
            <span class="selected-bar-label">已选组织：</span>
            <span v-if="selectedOrgName" class="selected-bar-name">{{ selectedOrgName }}</span>
            <span v-else class="selected-bar-placeholder">请在下方树中选择组织</span>
          </div>
          <el-button type="primary" size="small" @click="confirmSelectedOrg">确定选中</el-button>
        </div>

        <!-- 搜索框 -->
        <el-input placeholder="请输入要查询组织名称" v-model="filterText" clearable />
        <!-- 树 -->
        <el-tree class="filter-tree" :data="treeData" :props="defaultProps" :filter-node-method="filterNode"
          @node-click="handleNodeClick" ref="treeRef">
          <template #default="{ node, data }">
            <span class="custom-tree-item">
              <span class="level-tag">{{ node.level }}</span>
              <span class="tree-label">{{ data.name }}</span>
            </span>
          </template>
        </el-tree>
      </el-card>
    </div>
  </div>
</template>

<script>
import { teamAccounttree, teamshareteamTree } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { reactive, toRefs, watch, ref } from 'vue'


export default {
  name: 'ylyOrganizationTree',
  emits: ['getOrgData'],
  // 接收页面的传值
  props: ['datas'],
  setup(props, { emit }) {
    //模板ref，不能放进reactive
    const treeRef = ref(null)

    const state = reactive({
      //选中的节点id
      sid: '',
      depth: '',
      selectedOrgName: '',
      selectedOrgData: null,

      // ==========树相关参数==========
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      //点击节点
      handleNodeClick: (data) => {
        state.sid = data.id
        state.depth = data.depth
        state.selectedOrgName = data.name || ''
        state.selectedOrgData = data
      },

      // ==========确定选中==========
      confirmSelectedOrg: () => {
        if (!state.selectedOrgData) {
          ElMessage.error('请先选中组织')
        } else {
          const orgDatas = {
            id: state.selectedOrgData.id,
            name: state.selectedOrgData.name,
            type: props.datas
          }
          emit('getOrgData', JSON.parse(JSON.stringify(orgDatas)))
        }

      },
    })

    //================ setup顶层函数（和你示例handleSelectionChange同一层级）================
    /**树过滤回调，放在setup顶层，不放入state */
    const filterNode = (value, data) => {
      if (!value) return true
      return String(data.name || data.label || '').indexOf(value) !== -1
    }


    //查询树
    // const teamAccounttreeFun = () => {
    //   teamAccounttree({}).then((res) => {
    //     state.treeData = res.data || []
    //   }).catch(() => {
    //     ElMessage.error('组织树加载失败')
    //   })
    // }

    // teamAccounttreeFun()

    const teamshareteamTreeFun = () => {
      teamshareteamTree().then((res) => {
        state.treeData = res.data || []
      }).catch(() => {
        ElMessage.error('组织树加载失败')
      })
    }

    teamshareteamTreeFun()



    /**监听树搜索 */
    watch(
      () => state.filterText,
      (val) => {
        treeRef.value?.filter(val)
      }
    )



    //======= return范式： ...toRefs(state) ，再追加顶层ref、顶层函数 =======
    return {
      treeRef,
      ...toRefs(state),
      filterNode,
      // teamAccounttreeFun,
      teamshareteamTreeFun
    }
  },
}
</script>

<style lang="scss" scoped>
.selected-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding: 10px 12px;
  background: #f5f7fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
}

.selected-bar-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.selected-bar-label {
  flex-shrink: 0;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.selected-bar-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #409eff;
  font-size: 14px;
}

.selected-bar-placeholder {
  color: #909399;
  font-size: 14px;
}

.filter-tree {
  margin-top: 10px;
}

.custom-tree-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.level-tag {
  background-color: #e5e7eb;
  color: #666;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.tree-label {
  font-size: 14px;
}
</style>